import React from "react";
import _ from "lodash";
import * as Code from "@repoflow/components/code";
import { FormInput } from "@repoflow/form-schema/input";

export const View = (props) => {
  const { value } = props;
  return <span>{value}</span>;
};

export const Edit = (props) => {
  return <FormInput {...props}>{InputHandler}</FormInput>;
};

const InputHandler = (props) => {
  const {
    value,
    setValue,
    field: { height: heightCnf, fill },
    labelId,
    describedById,
  } = props;

  return (
    <Code.Control
      // What names the editor's `.cm-content` — the form's label and
      // description, whose ids arrive through FormInput. Both undefined in a
      // table cell, and the editor leaves an undefined one out.
      labelId={labelId}
      describedById={describedById}
      mode={"css"}
      value={value}
      onChange={setValue}
      layout={{
        width: "100%",
      }}
    />
  );
};
